let counter = 0;

const interval = setInterval(() => {
    if (BSS_B2B && window.location.pathname.includes("register")) {
        const title = document.querySelector(".bss-b2b-registration-form-title h1");
        if (title) {
            title.innerText = "Sign up";

            if (!document.querySelector(".bss-b2b-registration-subtitle")) {
                const sub = document.createElement("div");
                sub.className = "bss-b2b-registration-subtitle";
                sub.textContent = "Please fill in the information below:";

                title.insertAdjacentElement("afterend", sub);
            }
        }
        document.querySelector("#bss-b2b-registration-form").style.boxShadow="none";
        document.querySelector(".first_name").placeholder = "First name";
        document.querySelector(".last_name").placeholder = "Last name";
        document.querySelector(".email").placeholder = "Email";
        document.querySelector(".password").placeholder = "Password";
        document.querySelectorAll(".label-field").forEach(field => field.style.display = "none")
        const submitBtn = document.querySelector(".btn")
        if (submitBtn) {
            submitBtn.value = "CREATE ACCOUNT";
            submitBtn.classList.add("button");

            if (!document.querySelector(".bss-b2b-login-choice")) {
                const loginText = document.createElement("div");
                loginText.className = "bss-b2b-login-choice";
                loginText.textContent = "Already have an account? Login";

                loginText.style.cursor = "pointer";

                loginText.addEventListener("click", () => {
                    window.location.href = "/account/login";
                });

                submitBtn.insertAdjacentElement("afterend", loginText);
            }
        }
        clearInterval(interval);
    } else {
        counter += 100;
        if (counter >= 10000) {
            clearInterval(interval);
        }
    }
}, 100); 